/* Presentation and consent-aware diagnostics only. Shopify and the bundle app own commerce. */
(() => {
  const host = document.querySelector('.product__info-container');
  const journey = host?.querySelector('[data-nc-journey]');
  if (!journey) return;
  const form = host.querySelector('product-form form');
  const primary = form?.querySelector('[type="submit"][name="add"]');
  const sticky = document.querySelector('[data-nc-journey-sticky]');
  const stickyButton = sticky?.querySelector('[data-nc-sticky-add]');
  const selector = host.querySelector('nc-selection-summary');
  let state = { quantity: 1, total: Number(journey.dataset.price) };
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
    style: 'currency', currency: journey.dataset.currency, currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: value % 100 ? 2 : 0
  }).format(value / 100);
  const diagnostic = (name, data = {}) => {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    try { window.Shopify.analytics?.publish?.(name, { handle: journey.dataset.handle, ...data }); } catch {}
    if (typeof window.clarity === 'function') window.clarity('event', name);
  };
  const sync = () => {
    const q = Number(selector?.dataset.selectedQuantity);
    const total = Number(selector?.dataset.selectedTotal);
    if (q > 0 && total > 0) state = { quantity: q, total };
    const { quantity, total: selectedTotal } = state;
    const amount = money(selectedTotal);
    const contents = {
      'meridian-duo': [['plate',1],['bowl',1]],
      'the-pour-mug-tumbler-pair': [['mug',1],['cup',1]],
      'the-setting-complete-place-setting': [['plate',1],['bowl',1],['utensil',4]],
      'the-full-table-complete-collection': [['plate',1],['bowl',1],['utensil',4],['mug',1],['cup',1]],
      'meridian-cutlery': [['utensil',4]], 'meridian-plate': [['plate',1]], 'meridian-bowl': [['bowl',1]],
      'meridian-mug': [['mug',1]], 'meridian-cup': [['cup',1]]
    }[journey.dataset.handle];
    const summary = host.querySelector('[data-nc-selected-contents]');
    if (contents && summary) summary.textContent = contents.map(([noun,n])=>`${quantity*n} ${noun}${quantity*n===1?'':'s'}`).join(' + ');
    const label = primary?.querySelector('section-store--atc-main-text') || primary?.querySelector('span');
    primary?.classList.add('nc-journey-primary');
    const available = primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true';
    const text = `Add to cart · ${amount}`;
    if (available && label && label.textContent !== text) label.textContent = text;
    if (primary && available) primary.setAttribute('aria-label', text);
    if (sticky) {
      sticky.querySelector('[data-nc-sticky-price]').textContent = amount;
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? 'Add to cart' : primary?.getAttribute('data-nc-unavailable-label') || label?.textContent.trim() || 'Unavailable';
    }
  };
  host.addEventListener('nc:offer-state', event => {
    if (event.detail.handle !== journey.dataset.handle) return;
    state = event.detail;
    // The app bridge finishes updating its dataset in this task.
    queueMicrotask(() => { sync(); arrival(); });
  });
  sync();
  if (primary) new MutationObserver(sync).observe(primary, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
  stickyButton?.addEventListener('click', () => {
    if (!primary?.disabled && primary?.getAttribute('aria-disabled') !== 'true') primary.click();
  });
  const updateSticky = () => {
    if (!sticky || !primary) return;
    const overlay = document.querySelector('cart-drawer.active, menu-drawer details[open], header-drawer details[open], dialog[open], [data-nc-privacy]:not([hidden])');
    const rect = primary.getBoundingClientRect();
    const viewport = window.visualViewport;
    const top = viewport?.offsetTop || 0;
    const bottom = top + (viewport?.height || window.innerHeight);
    // Hand off as soon as the real button enters view, in either scroll direction.
    const primaryVisible = rect.bottom > top && rect.top < bottom;
    const show = !primaryVisible && !overlay;
    sticky.hidden = !show;
    document.body.classList.toggle('nc-journey-sticky-visible', show);
  };
  if (primary) new IntersectionObserver(updateSticky).observe(primary);
  updateSticky();
  window.addEventListener('resize', updateSticky, { passive: true });
  window.visualViewport?.addEventListener('resize', updateSticky, { passive: true });
  window.visualViewport?.addEventListener('scroll', updateSticky, { passive: true });
  document.addEventListener('scroll', updateSticky, { passive: true });
  document.addEventListener('click', () => requestAnimationFrame(updateSticky));
  document.addEventListener('keydown', () => requestAnimationFrame(updateSticky));
  document.querySelectorAll('cart-drawer, menu-drawer details, header-drawer details, dialog, [data-nc-privacy]').forEach(element => {
    new MutationObserver(updateSticky).observe(element, { attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
  });
  let arrivalSent = false;
  const arrival = () => {
    if (arrivalSent || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (host.querySelector('section-store--bundle-block') && selector && !selector.dataset.selectedQuantity && journey.dataset.handle === 'meridian-duo') return;
    arrivalSent = true;
    const requested = new URLSearchParams(location.search).get('offer');
    diagnostic('nc_offer_arrival', { offer: ['one-duo', 'two-duos', 'four-duos'].includes(requested) ? requested : 'default', quantity: state.quantity });
  };
  document.addEventListener('visitorConsentCollected', arrival);
  window.addEventListener('load', arrival, { once: true });
  host.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
    if (detail.open) diagnostic('nc_product_detail_opened', { detail: detail.dataset.ncDetail || 'product_details' });
  }));
  const error = host.querySelector('.product-form__error-message-wrapper');
  if (error) new MutationObserver(() => {
    if (!error.hidden) diagnostic('nc_cart_error', { category: 'cart_submission' });
  }).observe(error, { attributes: true, attributeFilter: ['hidden'] });
})();
